/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Measure the neck below the larynx, the waist at the navel for men or the narrowest point for women, and hips at the widest point, keeping the tape level and snug.`)
};

const es_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mide el cuello debajo de la laringe, la cintura a la altura del ombligo en hombres o en el punto más estrecho en mujeres, y las caderas en el punto más ancho, manteniendo la cinta nivelada y ajustada.`)
};

const de_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miss den Hals unterhalb des Kehlkopfs, die Taille bei Männern auf Höhe des Bauchnabels oder bei Frauen an der schmalsten Stelle und die Hüfte an der breitesten Stelle — halte das Maßband dabei waagerecht und eng anliegend.`)
};

const nl_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meet de nek onder het strottenhoofd, de taille ter hoogte van de navel bij mannen of het smalste punt bij vrouwen, en de heupen op het breedste punt, met het meetlint waterpas en strak.`)
};

const fr_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesurez le cou sous le larynx, la taille au niveau du nombril pour les hommes ou au point le plus étroit pour les femmes, et les hanches au point le plus large, en gardant le ruban de niveau et ajusté.`)
};

const it_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misura il collo sotto la laringe, la vita all'ombelico per gli uomini o nel punto più stretto per le donne, e i fianchi nel punto più largo, tenendo il metro in piano e aderente.`)
};

const pt_br2_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça o pescoço abaixo da laringe, a cintura na altura do umbigo para homens ou no ponto mais estreito para mulheres, e o quadril no ponto mais largo, mantendo a fita nivelada e justa.`)
};

const pt_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meça o pescoço abaixo da laringe, a cintura ao nível do umbigo nos homens ou no ponto mais estreito nas mulheres, e as ancas no ponto mais largo, mantendo a fita nivelada e justa.`)
};

const ja_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`首は喉頭の下、腰は男性はへその位置、女性は最もくびれた位置、ヒップは最も幅の広い位置を、メジャーを水平かつ密着させて測定してください。`)
};

const zh_bf_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`颈部测量喉结下方，腰部男性测脐部、女性测最细处，臀部测最宽处，皮尺应保持水平且贴合。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_faq_a2", locale)
	if (locale === "en") return en_bf_faq_a2(inputs)
	if (locale === "es") return es_bf_faq_a2(inputs)
	if (locale === "de") return de_bf_faq_a2(inputs)
	if (locale === "nl") return nl_bf_faq_a2(inputs)
	if (locale === "fr") return fr_bf_faq_a2(inputs)
	if (locale === "it") return it_bf_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_bf_faq_a2(inputs)
	if (locale === "pt") return pt_bf_faq_a2(inputs)
	if (locale === "ja") return ja_bf_faq_a2(inputs)
	return zh_bf_faq_a2(inputs)
};